export default __webpack_public_path__ + "static/media/pic33-before.7838b82d.jpg";